module.exports = __webpack_public_path__ + "static/media/feture_03.e74ab37.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/feture_03.mp4
// module id = QIcO
// module chunks = 1